module.exports = __webpack_public_path__ + "img/2_181.729078ec.png";